import { useState, useEffect } from "react";


const useModulosForm = (initialForm={}, autusuario, apibig) => {
  const [form, setForm] = useState(initialForm || {});
  const [datos, setDatos] = useState([]);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [response, setResponse] = useState(null);

  // Carga modulos
  useEffect(() => { 
    setForm(initialForm);
    fetchModulos(); 
  }, []);

    const fetchModulos = async () => {
      try {
        const res = await apibig.post("/api/roles/getmodulos", 
          { appid: autusuario.configuracion.proyecto, 
            email: autusuario.email, 
            basedatos: autusuario.configuracion.basedatos });
        setDatos(res.data);
      } catch (err) {
        setError("No se pudieron cargar los modulos.");
      } finally {
        setLoading(false);
      }
    };
  const handleChange = (e) => {    
    const { name, value } = e.target;
    setForm({
      ...form,
      [name]: value,
    });
      };

  // Manejo del submit
  const handleSubmit = async (e) => {
    e.preventDefault();
      /* const validationErrors = validate(form);
    setErrors(validationErrors);
    console.log(Object.keys(validationErrors))
    if (Object.keys(validationErrors).length === 0) {
      await guardarRol(form);
     // onSubmitCallback && onSubmitCallback(form);
      setForm(initialForm); // resetear si se desea
    }*/
  };
  const handleBlur = async (e) => {

  }

  // Validación simple (solo nombre requerido)
  const validate = (form) => {
    const newErrors = {};
    if (!form.Titulo || form.Titulo.trim() === "") {
      newErrors.Titulo = "El nombre del modulo es obligatorio.";
    }
    return newErrors;
  };



  return {
    form,
    datos,   
    loading,
    error,
    errors,
    response, 
    setDatos,
    handleBlur,
    handleChange,
    handleSubmit,
  };
};

export default useModulosForm;
